import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('schedule/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('schedule/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('schedule/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('schedule/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('schedule/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('schedule/delete', val_id);
  }

  listProjection(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('schedule/projection', val_params);
  }

  //  report queries
  viewSummary(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('schedule/view_summary', val_params);
  }

  // report guide data
  summaryToursByGuide(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('schedule/summary_tours/by_guide', val_params);
  }
  summaryCalendarByGuide(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all(
      'schedule/summary_calendar/by_guide',
      val_params
    );
  }

  // report transport data
  summaryToursByTransport(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('schedule/summary_tours/by_transport', val_params);
  }

  summaryCalendarByTransport(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all(
      'schedule/summary_calendar/by_transport',
      val_params
    );
  }
  
}
